<template>
  <div class="decorate full-screen">
    <img
      v-for="(item, index) of list"
      draggable="false"
      :key="index"
      :src="item.url"
      :style="{ width: `${item.width}vw` }"
      :class="[item.position]"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    list: {
      type: Array,
    },
  },
});
</script>

<style lang="less" scoped>
.decorate {
  position: absolute;
  left: 0;
  top: 0;
  z-index: @index-background;

  img {
    position: absolute;
    height: auto;

    &.top-left {
      top: 0;
      left: 0;
    }

    &.top-right {
      top: 0;
      right: 0;
    }

    &.bottom-left {
      bottom: 0;
      left: 0;
    }

    &.bottom-right {
      bottom: 0;
      right: 0;
    }
  }
}
</style>